import { setDebugMode } from './redux/app-ui/app-ui-actions';
require('babel-core/register');
require('babel-polyfill');
import './utils/polyfills';
import { syncTranslationWithStore } from 'react-redux-i18n';
import DP from './facades/data-provider';
import InitialState from './redux/initial-state';
import configureStore from './redux/configure-store';
import { exposeCTAs } from './facades/b2c-integration-facade';

//import {setAxiosInterceptors} from "./utils/axios/axios-interceptors";
import {
  routerHistory,
  redirectToDefaultPageIfNeeded
} from './routing/routing-lib';
import { setCommunicationWithWrapper } from './facades/wrapper-integration-facade';
import {
  getStateFromServer,
  getKambiConfigDataFromServer,
  listenMobileLookChanges,
  renderClientHTMLWithReact,
  runInitialActions,
  getConfigFromServer,
  setClientLogger,
  setCookie
} from './client-rendering';

// BEFORE REACT RENDER
//TODO[OT] why is this on window and not in some constant of ours?
window.sc_logger_uid = require('uuid/v4')();
window.libraryManager.UCSDKLibrary.ready.then(() => {
  setCookie();
  getConfigFromServer();
  setClientLogger();

  // get initial state & create the store
  const state = getStateFromServer();
  InitialState.setState(state);
  const store = configureStore(InitialState.getState());

  // get translations from store
  syncTranslationWithStore(store);

  // set axios interceptors(logging)
  //setAxiosInterceptors();

  // set communication with wrapper and b2c
  setCommunicationWithWrapper(store);
  exposeCTAs();

  //configure routerHistory
  routerHistory.createHashHistory();
  routerHistory.registerHistoryListener(store);

  // REACT RENDER
  const kambiConfigData = getKambiConfigDataFromServer();

  renderClientHTMLWithReact(store, kambiConfigData);

  // AFTER REACT RENDER
  listenMobileLookChanges(store);
  redirectToDefaultPageIfNeeded();
  DP.initSportProviderSocket(store);

  runInitialActions(store, null);

  window.startDebugMode = () => {
    store.dispatch(setDebugMode(true));
  };

  window.stopDebugMode = () => {
    store.dispatch(setDebugMode(false));
  };
});
